import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ADD_COMPANY_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { addCompanyNamesSuccess } from 'Actions';

const AddCompanyNamesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_COMPANY_NAMES_REQUEST),
    debounceTime(500),
    switchMap(({ link }) =>
      from(service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`)).pipe(
        map((response) => addCompanyNamesSuccess(response)),
        catchError((error) => {
          console.error('AddCompanyNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default AddCompanyNamesEpic;
